import StockProductSelect from "./stockProductSelect.container";

export default StockProductSelect;
